import { IconType, NavColor, Size, Sizes } from '@agilox/ui-common';
import { Component, computed, input, output, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'ui-icon',
	templateUrl: './icon.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: false,
	host: {
		'[class]': '"flex"',
	},
})
export class IconComponent {
	size = input<Size | '2xs'>(Sizes.S);
	type = input<IconType | NavColor | undefined>();
	icon = input<string | undefined>();
	styleClasses = input<string | undefined>();

	disabled = input<boolean>(false);
	action = input<boolean>(false);

	iconClicked = output<Event>();

	color = computed(() => {
		if (this.disabled()) {
			return 'var(--color-secondary-400)';
		}
		switch (this.type()) {
			case 'problem':
				return 'var(--color-problem)';
			case 'warning':
				return 'var(--color-warning)';
			case 'success':
				return 'var(--color-success)';
			case 'light':
				return 'var(--color-icon-light)';
			case 'dark':
				return this.action() ? 'var(--color-secondary-900)' : 'var(--color-secondary-800)';
			case 'primary':
				return this.action() ? 'var(--color-primary-900)' : 'var(--color-primary-700)';
			case 'error':
				return 'var(--color-error)';
			case 'input':
				return 'var(--color-input)';
			case 'active':
				return 'var(--color-primary)';
			default:
				return 'inherit';
		}
	});

	generalStyles = computed(() => {
		const inputClasses = this.styleClasses() ? this.styleClasses() + ' ' : '';

		if (this.disabled()) {
			return inputClasses + 'cursor-not-allowed';
		}

		if (this.action()) {
			return inputClasses + 'cursor-pointer';
		}

		return inputClasses;
	});

	clickedOnIcon(event: Event) {
		// prevents the event when icon is disabled
		if (this.disabled()) {
			event.preventDefault();
			event.stopImmediatePropagation();
			event.stopPropagation();
		} else {
			this.iconClicked.emit(event);
		}
	}
}
